import dayjs from "dayjs";
import { FormattedMessage } from "react-intl";

export const getErrorMessage = (
  error,
  inputProps,
  rest,
  label = "This feild"
) => {
  switch (error) {
    case "required":
      return (
        <FormattedMessage
          id="field_required"
          values={{ label }}
          defaultMessage="This field is required"
        />
      );
    case "duplicate":
      return `Duplicate ${label} found.`;
    case "maxlength":
      return `${label} should contain ${rest.maxLength} ${
        inputProps.type === "number" ? "digits" : "character"
      }.`;
    case "minlength":
      return `${label} should contain ${rest.minLength} ${
        inputProps.type === "number" ? "digits" : "character"
      }.`;
    case "confirmPasswordMismatch":
      return (
        <FormattedMessage
          id="confirm_password_not_match"
          values={{ label }}
          defaultMessage="Confirm Password doesn't match Password."
        />
      );
    case "oldPasswordSame":
      return `${label} should not match Current Password.`;
    case "invalidStrengthPassword":
      return `${label} should at least 7 characters and must contain at least one numeric digit and a special character.`;
    case "invalidEmail":
      return (
        <FormattedMessage
          id="invalid_email"
          defaultMessage="Please enter valid email"
        />
      );
    case "invalidNumber0":
      return `${label} should be greater than 0.`;
    case "maxDate":
      return `${label} cannot be greater than today.`;
    case "invalidNumber+":
      return `${label} should be greater than or equal to 0.`;
    case "maxCombinedValue":
      return `Total cannot be greater than ${rest.totalvalue}`;
    case "emailExists":
      return (
        <FormattedMessage
          id="email_exists"
          defaultMessage="Email already in use. Please try another email."
        />
      );
    case "subDomainExists":
      return (
        <FormattedMessage
          id="subdomain_exists"
          defaultMessage="Subdomain already in use. Please try another subdomain."
        />
      );
    case "nameIsUse":
      return (
        <FormattedMessage
          id="name_in_use"
          defaultMessage="Name already in use. Please try another name."
        />
      );
    case "minDate":
      return `${label} cannot be less than ${dayjs(
        rest?.minDate || new Date()
      ).format("DD MMM, YYYY")}.`;
    case "invalidAlpha":
      return `${label} should contain only alphabets & space.`;
    case "invalidStrongPassword":
      return `${label} should contain at least 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character.`;
    default:
      return "";
  }
};

export const bytesToNextBiggerUnit = (bytes) => {
  const units = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let i = 0;
  while (bytes >= 1024 && i < units.length - 1) {
    bytes /= 1024;
    i++;
  }
  return `${bytes.toFixed(2)} ${units[i]}`;
};
